import React, { FC, CSSProperties } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';

interface CommonButtonProps {
	color?:string;
	activeColor?: string
	activeTextColor?: string
	buttonText: string;
	onClick?: () => void;
	className?: string;
	style?: CSSProperties;
}

interface CommonButtonStylesProps {
	color :string;
	activeColor: string
	activeTextColor: string
}


const useStyles = makeStyles({
	root: {
		width: '100%',
		maxWidth: 250,
		height: 64,
		borderWidth: 1,
		borderRadius: 16,
		borderStyle: 'solid',
		borderColor: (props: CommonButtonStylesProps) => props.color, // 'var(--color-tertiary)'
		backgroundColor: 'var(--color-white)',
		fontFamily: 'MSung HK',
		fontWeight: 400,
		fontSize: 24,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'all 0.2s ease-in-out',
		
		'&:active, &:hover': {
			backgroundColor: (props: CommonButtonStylesProps) => props.activeColor,
			'& span': {
				color:  (props: CommonButtonStylesProps) => props.activeTextColor,
			}
		},

		'& span': {
			color: (props: CommonButtonStylesProps) => props.color,
		}
	},
});

const CommonButton: FC<CommonButtonProps> = ({
	color='var(--color-tertiary)', // text color 
	activeColor='var(--color-tertiary)',
	activeTextColor='var(--color-white)',
	buttonText,
	onClick,
	className,
	style,
}) => {
	const classes = useStyles({ color, activeColor, activeTextColor });

	return (<button
		className={cx(classes.root, className)}
		style={{
			...style,
			borderColor: color
		}}
		onClick={onClick}
	>
		<Typography variant='button'>
			{ buttonText }
		</Typography>
	</button>);
};

export default CommonButton;
